import { usePage } from "@inertiajs/vue3";

const asset = (pathToImage : string) : string => {
    return usePage().props.base_url + 'storage/' + pathToImage;
};

export default asset;
